import React from 'react';
import { styled, ThemeProvider } from '@mui/material/styles';
import { Box, Checkbox, FormControlLabel, FormGroup, Paper, Stack, Typography } from '@mui/material';
import styles from './styles';
import { LightTheme } from '@mercedes-benz/mbui-theme';

const ResultAreaRoot = styled(Paper)(styles);

const ResultArea = ({matchedConfiguration}) => {    
    const [interests, setInterests] = React.useState({
        free_cooling: false,
        warranty_options: false,
        maintenance_options: false,
        financing_options: false,
        grid_integration_services: false
    });

    const handleInterestChange = (event) => {
        setInterests({
            ...interests,
            [event.target.value]: event.target.checked
        });
    };

    const render = () => {
        return (
            <ThemeProvider theme={LightTheme}>
                <ResultAreaRoot elevation={1} className="ResultArea-root">
                    <Stack direction="row" gap={2} justifyContent={'space-evenly'} className="ResultArea-stack">
                        {matchedConfiguration ? (
                            <>
                                <Box>
                                    <Typography variant="h4" component="p">Footprint</Typography>
                                    <table className="Footprint-table">
                                        <tbody>
                                            <tr>
                                                <td>Length</td>
                                                <td>{matchedConfiguration.length}</td>
                                            </tr>
                                            <tr>
                                                <td>Width</td>
                                                <td>{matchedConfiguration.width}</td>
                                            </tr>
                                            <tr>
                                                <td>Weight</td>
                                                <td>{matchedConfiguration.weight}</td>
                                            </tr>
                                            <tr>
                                                <td>Units</td>
                                                <td>{matchedConfiguration.numberOfStrings}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </Box>    
                                <Box className="AdditionalOptions-root">
                                    <Typography variant="h4" component="p">I need more information about</Typography>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disableRipple
                                                    name='interests'
                                                    value="free_cooling"
                                                    checked={interests.free_cooling}
                                                    onChange={handleInterestChange}
                                                />
                                            }
                                            label="Free cooling"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disableRipple
                                                    name='interests'
                                                    value="warranty_options"
                                                    checked={interests.warranty_options}
                                                    onChange={handleInterestChange}
                                                />
                                            }
                                            label="Warranty options"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disableRipple
                                                    name='interests'
                                                    value="maintenance_options"
                                                    checked={interests.maintenance_options}
                                                    onChange={handleInterestChange}
                                                />
                                            }
                                            label="Maintenance options"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disableRipple
                                                    name='interests'
                                                    value="financing_options"
                                                    checked={interests.financing_options}
                                                    onChange={handleInterestChange}
                                                />
                                            }
                                            label="Financing options"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    disableRipple
                                                    name='interests'
                                                    value="grid_integration_services"
                                                    checked={interests.grid_integration_services}
                                                    onChange={handleInterestChange}
                                                />
                                            }
                                            label="Grid Integration services"
                                        />
                                    </FormGroup>
                                    <input type="hidden" name="interests" value={Object.entries(interests).filter(([key, value]) => value).map(([key, value]) => key).join(', ')} />
                                </Box>
                            </>
                        ):'Please request an individual quote.'}                        
                    </Stack>
                </ResultAreaRoot>
            </ThemeProvider>
        )
    };

    return render();
};

ResultArea.propTypes = {};

export default ResultArea;